import { render } from "./content.vue?vue&type=template&id=2336f726&scoped=true&ts=true"
import script from "./content.vue?vue&type=script&lang=ts"
export * from "./content.vue?vue&type=script&lang=ts"

import "./content.vue?vue&type=style&index=0&id=2336f726&lang=less&scoped=true"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2336f726"]])

export default __exports__